module.exports = __webpack_public_path__ + "img/p14.a05261c9.png";